import initialState from './initialState';
import {
  FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE,
  FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS,
  FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL,
  FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED,
} from './types';

export default function GLAccountListReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        accounts: action.accounts,
      };
    case FETCH_ACCOUNTS_FOR_GL_ACCOUNT_LIST_FAILURE:
      return {
        ...state,
        accounts: initialState.accounts,
      };
    case FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: true,
      };
    case FETCHING_DATA_FOR_GL_ACCOUNTS_LIST_MODAL_FINISHED:
      return {
        ...state,
        isFetchingInitialDataForAddAndEditModal: false,
      };
    default:
      return state;
  }
}
